// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKING!
export const VERSION = {
    "dirty": false,
    "raw": "v2.0.6-0-g084dce72",
    "hash": "g084dce72",
    "distance": 0,
    "tag": "v2.0.6",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v2.0.6",
        "major": 2,
        "minor": 0,
        "patch": 6,
        "prerelease": [],
        "build": [],
        "version": "2.0.6"
    },
    "suffix": "0-g084dce72",
    "semverString": "2.0.6",
    "version": "2.0.6"
};
